import { useRef, type JSX, type ReactNode } from 'react';

import type { GuideTipResponse } from '@/api/generated/model';

import { useImpression } from './use-impression';

/**
 * Wraps one rendered tip and reports it as seen once it has been half on
 * screen for a second (`useImpression`). The wrapper is a plain block, so the
 * observer has a box to measure (a `display: contents` element has none).
 */
export function SeenTip({
  tip,
  rank,
  onSeen,
  children,
}: {
  tip: GuideTipResponse;
  rank: number;
  onSeen: (tip: GuideTipResponse, rank: number) => void;
  children: ReactNode;
}): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);
  useImpression(ref, () => onSeen(tip, rank));
  return (
    <div ref={ref} className="bk-guide-seen">
      {children}
    </div>
  );
}
